import { Link as GatsbyLink } from "gatsby"
import styled from "@emotion/styled"
import { css } from '@emotion/react'

import { viewOnLight } from './theme/light'
import { viewOnDark } from './theme/dark'

const size = ({ size }) => {
  if (size === 300) {
    return css({
      font:         "var(--text-540)",
      borderRadius: 4,
      gap:          4,

      "& > svg": {
        width:  16,
        height: 16
      }
    })
  }
  else if (size === 250) {
    return css({
      font:         "var(--text-340)",
      borderRadius: 4,
      gap:          4,

      "& > svg": {
        width:  14,
        height: 14
      }
    })
  }
}

export const Text = styled.span({
  position: "relative",

  "&:before": {
    content: "''",
    position: "absolute",
    transition: "opacity var(--fast-transition)",
    opacity: 0,
    background: "currentColor",
    height: 1,
    bottom: 0,
    left: 0,
    right: 0
  }
})

export const Link = styled(GatsbyLink)({
  display: "inline-flex",
  alignItems: "center",
  flexShrink: 0,
  textDecoration: "none",
  transition: "color var(--fast-transition)",
}, viewOnLight, viewOnDark, size)

export const A = Link.withComponent("a")
